import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    comment: {
        id: 'iaso.storages.comment',
        defaultMessage: 'Comment',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    confirm: {
        id: 'iaso.mappings.confirm',
        defaultMessage: 'Confirm',
    },
    writeProfile: {
        defaultMessage: 'Write profile',
        id: 'iaso.storages.writeProfile',
    },

    clear: {
        id: 'iaso.label.clear',
        defaultMessage: 'Clear',
    },
    reset: {
        defaultMessage: 'Reset',
        id: 'iaso.storages.reset',
    },
    read: {
        defaultMessage: 'Read',
        id: 'iaso.storages.read',
    },
    writeRecord: {
        defaultMessage: 'Write record',
        id: 'iaso.storages.writeRecord',
    },
    changeStatus: {
        defaultMessage: 'Change status',
        id: 'iaso.storages.changeStatus',
    },
    date: {
        defaultMessage: 'Date',
        id: 'iaso.label.date',
    },
    logs: {
        defaultMessage: 'Logs',
        id: 'iaso.storages.logs',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    last_sync_at: {
        id: 'iaso.entities.label.last_sync_at',
        defaultMessage: 'Last sync',
    },
    title: {
        defaultMessage: 'External storage',
        id: 'iaso.label.storages',
    },
    info: {
        defaultMessage: 'Informations',
        id: 'iaso.instance.infos',
    },
    storage: {
        defaultMessage: 'Storage',
        id: 'iaso.label.storage',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    type: {
        defaultMessage: 'Storage type',
        id: 'iaso.label.storageType',
    },
    operationType: {
        defaultMessage: 'Operation type',
        id: 'iaso.label.operationType',
    },
    nfc: {
        defaultMessage: 'NFC',
        id: 'iaso.storages.nfc',
    },
    usb: {
        defaultMessage: 'USB',
        id: 'iaso.storages.usb',
    },
    sd: {
        defaultMessage: 'SD',
        id: 'iaso.storages.sd',
    },
    OK: {
        defaultMessage: 'Ok',
        id: 'iaso.storages.status.ok',
    },
    BLACKLISTED: {
        defaultMessage: 'Blacklisted',
        id: 'iaso.storages.status.blacklisted',
    },
    status: {
        defaultMessage: 'Status',
        id: 'iaso.storages.status.label',
    },
    reason: {
        defaultMessage: 'Reason',
        id: 'iaso.table.status.reason',
    },
    stolen: {
        defaultMessage: 'Stolen',
        id: 'iaso.storages.reason.stolen',
    },
    lost: {
        defaultMessage: 'Lost',
        id: 'iaso.storages.reason.lost',
    },
    damaged: {
        defaultMessage: 'Damaged',
        id: 'iaso.storages.reason.damaged',
    },
    abuse: {
        defaultMessage: 'Abuse',
        id: 'iaso.storages.reason.abuse',
    },
    other: {
        defaultMessage: 'Other',
        id: 'iaso.storages.reason.other',
    },
    location: {
        defaultMessage: 'Location',
        id: 'iaso.forms.location',
    },
    entity: {
        defaultMessage: 'Entity',
        id: 'iaso.label.entity',
    },
    user: {
        defaultMessage: 'User',
        id: 'iaso.label.user',
    },
    submissions: {
        defaultMessage: 'Submissions',
        id: 'iaso.instance.title',
    },
});

export default MESSAGES;
